import React, { useCallback, useMemo } from 'react'

import { AIAssistantChatFragment } from 'types/graphql'

import CreateCustomAnswerButton from 'src/pages/AIAssistantHistoryPage/CreateCustomAnswerButton'
import EditCustomAnswerButton from 'src/pages/AIAssistantHistoryPage/EditCustomAnswerButton'
import LinkArea from 'src/pages/AIAssistantHistoryPage/LinkArea'
import Message from 'src/pages/AIChat/AIResponseMessage/Message'
import { RefetchFnType } from 'src/types'

type Props = {
  chat: AIAssistantChatFragment
  index: number
  refetch: RefetchFnType
  onSelectResponse?: (response: string) => void
}
const AIChatDisplay = ({ chat: c, index, refetch, onSelectResponse }: Props) => {
  const children = (
    <>
      {c.question && (
        <Message sender="user" html={c.question} index={index} sentAt={c.questionCreatedAt ?? ''} />
      )}
      {c.response && <Message sender="ai" html={c.response} index={index} shouldDisableButtons />}
    </>
  )

  const handleSelectResponse = useCallback(() => {
    if (c.response) {
      onSelectResponse?.(c.response)
    }
  }, [c.response, onSelectResponse])

  const customAnswer = useMemo(() => {
    return c.aiChatbotFAQ?.type === 'Answered' ? c.aiChatbotFAQ : null
  }, [c.aiChatbotFAQ])

  if (onSelectResponse) {
    return c.response ? (
      <LinkArea cta="Use this response" highlightMode="hover" onClick={handleSelectResponse}>
        {children}
      </LinkArea>
    ) : (
      <>{children}</>
    )
  }

  return customAnswer ? (
    <EditCustomAnswerButton aiChatbotFAQ={customAnswer} refetch={refetch}>
      {children}
    </EditCustomAnswerButton>
  ) : (
    <CreateCustomAnswerButton aiChat={c} refetch={refetch}>
      {children}
    </CreateCustomAnswerButton>
  )
}

export default React.memo(AIChatDisplay)
